import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { FinxAiLogoWithText } from "./finxai-logo-with-text";
import WebSocketConnectionStatusIndicator from "./web-socket-connection-indicator";

export const FinxAiFooter = () => {
  const { messageStats } = useSelector((state: RootState) => state.data);
  const { pathname } = useLocation();

  return (
    <div className="flex flex-row justify-between items-center p-2 bg-secondary">
      <div className="flex flex-row items-center gap-6 ml-4">
        <div className="flex flex-col text-white text-xs">
          <span className="font-semibold">Messages Received</span>
          <div className="flex gap-4 mt-1">
            <span title="Trade Messages">Trades: {messageStats.tradeCount.toLocaleString()}</span>
            <span title="Market Data Messages">Market: {messageStats.marketDataCount.toLocaleString()}</span>
            <span title="Strategy Messages">Strategies: {messageStats.strategyCount.toLocaleString()}</span>
          </div>
        </div>
      </div>
      {pathname === "/home" && (
        <div className="text-yellow-400 text-lg font-bold text-center">
          If you do not see your working order, please contact the desk.
        </div>
      )}
      <div className="flex flex-row items-center">
        <div className="mx-4">
          <WebSocketConnectionStatusIndicator />
        </div>
        {/*
        {window.location.pathname === "/" && (
          <>
            <span className="text-white">Powered by</span>
            <div className="scale-90">
              <FinxAiLogoWithText />
            </div>
          </>
        )}
        */}
      </div>
    </div>
  );
};
